import React from 'react';
import type { TFunction } from 'i18next';

import { Grid } from '../../../common/components/Grid/Grid';
import {
  GridColumn,
  GridCountFunction,
  GridGetterFunction,
} from '../../../common/components/Grid/GridDataTypes';
import { GetStageHintDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import {
  TimelineHintDeadlineObj,
  TimelineStageObj,
} from '../../../common/pokCore/validation/enums';
import { TKeys, useTranslation } from '../../../translations';

interface HintsSearchProps {
  getData: GridGetterFunction;
  getCount: GridCountFunction;
  onRowClick: (key: string) => Promise<void> | void | undefined;
  refresh?: boolean;
}

export const timeLineHintsForGrid = (
  hints: GetStageHintDto,
  t: TFunction<'projectLng', 'projectLng'>,
  tk: TKeys<'projectLng'>,
) => {
  return {
    key: hints.id,
    values: {
      'hints.descriptionPl': hints.descriptionPl,
      'hints.descriptionEn': hints.descriptionEn,
      'hints.order': hints.order,
      'hints.active': hints.active ? t(tk.common.yes) : t(tk.common.no),
      'hints.deadline': t(TimelineHintDeadlineObj[hints.deadline]),
      'stageDefinition.name': t(
        TimelineStageObj[hints.stageDefinition.stageType],
      ),
      // 'hints.url': hints.url ? t(tk.common.yes) : t(tk.common.no),
    },
    orderByNumberValues: {
      'hints.order': hints.order,
    },
    isInactive: !hints.active,
  };
};

export const HintsSearch: React.FC<HintsSearchProps> = props => {
  const { t, tk } = useTranslation('projectLng');
  const columns: GridColumn[] = [
    {
      header: t(tk.timeLine.stageOnTimeline),
      property: 'stageDefinition.name',
      noSorting: true,
    },
    { header: t(tk.timeLine.order), property: 'hints.order' },
    { header: t(tk.timeLine.description), property: 'hints.descriptionPl' },
    { header: t(tk.timeLine.descriptionEn), property: 'hints.descriptionEn' },
    { header: t(tk.timeLine.deadline), property: 'hints.deadline' },
    // {
    //   header: t(tk.timeLine.linkInSystem),
    //   property: 'hints.url',
    //   noFilter: true,
    //   noSorting: true,
    // },
  ];

  return (
    <Grid
      getData={props.getData}
      getDataCount={props.getCount}
      columns={columns}
      showFilter={true}
      initialOrderColumn="hints.order"
      availablePageSizes={[10, 20, 50]}
      emptyGridMessage={t(tk.timeLine.noHints)}
      onRowClick={props.onRowClick}
      refresh={props.refresh}
      withHistory={true}
      showExport={true}
    />
  );
};
